import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LoadingController {
  #visible = false;
  #message = "";

  constructor() {}

  get visible() {
    return this.#visible;
  }

  get message() {
    return this.#message;
  }

  /**
   * Display the root loading dialogue
   * @param param0
   */
  async present({ message = "" }: { message?: string } = {}): Promise<void> {
    this.#visible = true;
    this.#message = message;
    await this.waitForAnimation();
    return;
  }

  async dismiss(): Promise<void> {
    this.#visible = false;
    this.#message = "";
    await this.waitForAnimation();
    return;
  }

  /**
   * Replicates animation duration > 150ms cubic-bezier(0, 0, 0.2, 1)
   * @returns
   */
  private waitForAnimation(): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, 150));
  }
}
